export enum HookPriority {
  HIGHEST = 100,
  HIGH = 200,
  DEFAULT = 500,
  LOW = 800,
  LOWEST = 900,
}
